import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import Page from '../page';
import MPHeader from './mp-header';
import { createPath, choosePath } from '../helpers';
import Footer from '../footer';

const Email = (props) => {
  const {
    title,
    lead,
    parties,
    electorates,
    selectedMP,
    redirectUrl,
    totalSteps,
    hideLookupStep,
    userInput: {
      selectedElectorateId,
      selectedPartyId,
      selectedMPId,
      firstName,
      lastName,
      email,
      personalMessage,
      subject,
      message
    },
    setUserInput,
    sendEmail,
    sendEmailComplete,
    processingSendEmail,
    sendEmailErrorMessage
  } = props;

  if (sendEmailComplete) {
    if (redirectUrl) {
      window.location = redirectUrl;
    } else {
      return <Redirect to="/thanks" />;
    }
  }

  if (!firstName || !lastName || !email || !personalMessage || !message) {
    if (selectedMPId) {
      return (
        <Redirect
          to={createPath({
            mp: selectedMPId,
            electorate: selectedElectorateId,
            party: selectedPartyId
          })}
        />
      );
    }
    return (
      <Redirect
        to={choosePath({
          electorate: selectedElectorateId,
          party: selectedPartyId
        })}
      />
    );
  }

  // Get all data
  const selectedMPParty = parties.find((p) => p.id === selectedMP.partyId);
  const selectedMPElectorate = electorates.find(
    (e) => e.id === selectedMP.electorateId
  );

  // render components
  const footer = (
    <Footer
      step={hideLookupStep ? 3 : 4}
      totalSteps={totalSteps}
      left={
        <Link
          to={createPath({
            mp: selectedMPId,
            electorate: selectedElectorateId,
            party: selectedPartyId
          })}
          className="btn btn-outline-redpink btn-block"
        >
          ← Edit
        </Link>
      }
      right={
        <React.Fragment>
          {!processingSendEmail && (
            <button type="submit" className="btn btn-redpink btn-block">
              Send <i className="fas fa-paper-plane pl-1" aria-hidden="true" />
            </button>
          )}
          {processingSendEmail && (
            <button
              type="submit"
              disabled
              className="btn btn-redpink btn-block"
            >
              Sending{' '}
              <i
                className="fas fa-circle-notch fa-spin pl-1"
                aria-hidden="true"
              />
            </button>
          )}
        </React.Fragment>
      }
    />
  );

  const InfoPanel = () => (
    <React.Fragment>
      <p>
        <strong>You're almost there!</strong>
      </p>
      <p>
        Here is the message that will be sent to {selectedMP.name} on your
        behalf.
      </p>
      <p>
        In order to maximise your impact, we recommend personalising your
        message before you press send.
      </p>
      <p>
        MPs receive hundreds, sometimes thousands, of emails, letters and calls
        from members of the public every week so the more you can make yours
        stand out from the crowd, the better!
      </p>
      <p>
        While we understand many of us are passionate about this issue, it's
        important to avoid disrespectful language. We won’t always agree with
        everything every MP does, but it won’t help advance our vision and
        values by casting insults at decision makers.
      </p>
      <p>
        Finally, all messages sent via ActionStation go through a process of
        moderation. We will not send them if they are insulting, rude,
        threatening, violent, bullying, homophobic, xenophobic, sexist, racist,
        transphobic, ableist, body-shaming etc. This is part of our commitment
        to a healthy and inclusive internet for everyone.
      </p>
    </React.Fragment>
  );

  // render page
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        sendEmail();
      }}
    >
      <Page
        title={title}
        infoPanel={<InfoPanel />}
        header={
          <MPHeader
            mp={selectedMP}
            party={selectedMPParty}
            electorate={selectedMPElectorate}
          />
        }
        lead={lead}
        footer={footer}
      >
        <div className="form-group">
          <p className="h5" htmlFor="message">
            Your message to {selectedMP.name}, which you can preview and edit
            before sending
          </p>
          <br />

          <div className="form-group">
            <label className="h5" htmlFor="custom_subject">
              Subject
            </label>
            <input
              id="custom_subject"
              name="custom_subject"
              type="text"
              className="form-control form-control-sm"
              required
              value={subject}
              onChange={(event) =>
                setUserInput({ subject: event.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label className="h5" htmlFor="message">
              Message
            </label>
            <textarea
              id="message"
              name="message"
              className="form-control form-control-sm"
              rows="20"
              required
              value={message}
              onChange={(event) =>
                setUserInput({ message: event.target.value })
              }
            />
          </div>
        </div>

        <p className="text-danger">{sendEmailErrorMessage}</p>
      </Page>
    </form>
  );
};

export default Email;
